
import {defineComponent} from "vue";
import BaseContainer from "@/components/UI/Bootstrap/BaseContainer.vue";
import BaseTitle from "@/components/UI/BaseTitle.vue";
import {AbilityContext} from "@/context/AbilityContext";

export default defineComponent({
  name: "PharmaAppointments",
  components: {
    BaseTitle, BaseContainer
  },
  data() {
    return {
      isAuthorized: AbilityContext.isAuthorizedForFeature('CALENDAR_INTEGRATION'),
    };
  },
});
